import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'partial/components/Button';
import icon from 'assets/images/icons/icon.svg';

function PageNotFound() {
  const navigate = useNavigate();
  return (
    <div className="h-screen pt-16 pb-12 flex flex-col bg-gray-50">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <a href="/" className="inline-flex">
            <span className="sr-only">Workflow</span>
            <figure>
              <img className="h-full" src={icon} alt="icon" />
            </figure>
          </a>
        </div>
        <div className="pb-16 pt-4">
          <div className="text-center">
            <p className="font-semibold text-lg text-primary-600 uppercase tracking-wide">
              404 error
            </p>
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Page not found.
            </h1>
            <p className="mt-2 text-base text-gray-500">
              Sorry, we couldn’t find the page you’re looking for.
            </p>
            <div className="mt-6 text-center">
              <Button className="mx-auto" default onClick={() => navigate('/')}>
                Go to to homepage<span aria-hidden="true"> &rarr;</span>
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

PageNotFound.propTypes = {};

export default PageNotFound;
